export const findItemByLineNumber = (items = [], lineNumber) =>
  items.find(item => item.lineNumber === lineNumber);
